module.exports = __webpack_public_path__ + "static/media/3.fd854c7b.jpg";